let subscribers = {};

function subscribe(eventName, callback) {
  if (subscribers[eventName] === undefined) {
    subscribers[eventName] = [];
  }

  subscribers[eventName] = [...subscribers[eventName], callback];

  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter((cb) => {
      return cb !== callback;
    });
  };
}

function publish(eventName, data) {
  if (subscribers[eventName]) {
    // A subscriber throwing synchronously must not stop the remaining
    // subscribers from running, and must not propagate back into the
    // publisher's own call site (e.g. product-form.js relies on code after
    // `publish()` still running even if one unrelated listener is broken).
    const promises = subscribers[eventName].map((callback) => {
      try {
        return callback(data);
      } catch (e) {
        console.error(e);
        return undefined;
      }
    });
    return Promise.all(promises);
  } else {
    return Promise.resolve()
  }
}
